"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_merge_1 = __importDefault(require("lodash.merge"));
/**
 * Given a bid, this will flatten the partnerId and size
 * alongisde any partner-specific targeting,
 * which are otherwise transparently passed to Adzerk
 */
function default_1(bid) {
    var _a, _b, _c;
    var targeting = {};
    var sourceTargeting = (_b = (_a = bid === null || bid === void 0 ? void 0 : bid.source_bid) === null || _a === void 0 ? void 0 : _a.targeting) !== null && _b !== void 0 ? _b : {};
    targeting.partnerId = (_c = bid === null || bid === void 0 ? void 0 : bid.partner) !== null && _c !== void 0 ? _c : null;
    targeting.ixWidth = bid.dimensions ? bid.dimensions.split("x")[0] : "1";
    targeting.ixHeight = bid.dimensions ? bid.dimensions.split("x")[1] : "1";
    return (0, lodash_merge_1.default)(targeting, sourceTargeting);
}
exports.default = default_1;
